import { render, staticRenderFns } from "./PracticeBillingPage.vue?vue&type=template&id=8dc9d38c&scoped=true"
import script from "./PracticeBillingPage.vue?vue&type=script&lang=js"
export * from "./PracticeBillingPage.vue?vue&type=script&lang=js"
import style0 from "./PracticeBillingPage.vue?vue&type=style&index=0&id=8dc9d38c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc9d38c",
  null
  
)

export default component.exports